export default __webpack_public_path__ + "static/media/manage_heroicons_exclaimation-circle.ef2384c1.svg";